<template>
    <div class="modal-backdrop" @click.self="close">
        <div class="modal-content">
            <button
                type="button"
                class="absolute top-2  right-2 leading-none bg-transparent text-xl btn-close"
                aria-label="Close"
                @click="close"
            >
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 320 512"
                    style="width: 25px; height: 25px;"
                >
                    <path
                        d="M193.94 256L296.5 153.44l21.15-21.15c3.12-3.12 3.12-8.19 0-11.31l-22.63-22.63c-3.12-3.12-8.19-3.12-11.31 0L160 222.06 36.29 98.34c-3.12-3.12-8.19-3.12-11.31 0L2.34 120.97c-3.12 3.12-3.12 8.19 0 11.31L126.06 256 2.34 379.71c-3.12 3.12-3.12 8.19 0 11.31l22.63 22.63c3.12 3.12 8.19 3.12 11.31 0L160 289.94 262.56 392.5l21.15 21.15c3.12 3.12 8.19 3.12 11.31 0l22.63-22.63c3.12-3.12 3.12-8.19 0-11.31L193.94 256z"
                    />
                </svg>
            </button>
            <h2>Du gik glip af de nødvendige oplysninger. Udfyld dem, før du fortsætter.</h2>
            <div class="modal-actions">
                <button @click.prevent="confirmSubscription" class="btn btn-primary">OPDATER PROFIL</button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        hasBillingDetails: {
            type: Boolean,
            required: true,
        },
        hasCardBrand: {
            type: Boolean,
            required: true,
        },
        hasCVRNumber: {
            type: Boolean,
            required: true,
        }
    },
    methods: {
        close() {
            this.$emit('close');
        },
        confirmSubscription() {
            // Check for missing details and trigger corresponding clicks
            if (!this.hasBillingDetails) {
                const billingButton = document.querySelector('[aria-controls="information"]');
                if (billingButton) {
                    billingButton.click();
                }
            }
            if (!this.hasCardBrand) {
                const cardBrandButton = document.querySelector('[aria-controls="billing"]');
                if (cardBrandButton) {
                    cardBrandButton.click();
                }
            }
            if (!this.hasCVRNumber) {
                const cvrButton = document.querySelector('[aria-controls="information"]');
                if (cvrButton) {
                    cvrButton.click();
                }
            }
            // console.log('Subscription confirmation checked for plan:', this);

            // Optional: Close modal after checks
            // this.close();
        },
    },
}
</script>

<style scoped>
.modal-backdrop {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
}
.modal-content {
    background-color: white;
    padding: 4rem;
    border-radius: 0;
    max-width: 700px;
    box-shadow: none;
}
.modal-content::before {
    content: '';
    display: block;
    width: 50px;
    height: 25%;
    background: #ffffff;
    position: absolute;
    top: 0;
    left: -50px;
}
.modal-content::after {
    content: '';
    display: block;
    width: 50px;
    height: 78%;
    background: #ffffff;
    position: absolute;
    top: 21%;
    left: -18px;
    transform: rotate(-11deg);
}
.modal-content h2 {
    font-size: 24px;
    font-weight: 900;
    text-align: center;
    letter-spacing: 0px;
    color: #1825d8;
    text-transform: uppercase;
    opacity: 1;
}
.btn-close {
    border: 1px solid #1825d8;
}
.btn-close svg {
    fill: #1825d8;
}
.modal-actions {
    margin-top: 20px;
    display: flex;
    justify-content: center;
}
.btn {
    padding: 10px 20px;
    border: none;
    border-radius: 0;
    cursor: pointer;
}
.btn-primary {
    background-color: #1825d8;
    color: white;
}
</style>
